import React from "react";

function useFormatedDropdownData(
  data,
  keyName,
  labelName,
  rerenderingCondition,
  combineValueKey,
  combineValue,
) {
  const [formatedData, setFormatedData] = React.useState([]);

  React.useEffect(() => {
    const format = data?.map((item) => ({
      value: keyName ? item[keyName] : item,
      label: labelName ? item[labelName] : item,
    }));
    const unique = {};
    const uniqueData = format?.filter((item) => {
      if (!unique[item.label]) {
        unique[item.label] = true;
        return true;
      }
      return false;
    });

    setFormatedData(uniqueData);
  }, [data, rerenderingCondition, combineValue, combineValueKey]);

  return { data: formatedData };
}

export default useFormatedDropdownData;
